import { Typography } from "@mui/material";
import { Link } from "Navigation/Link";

/** Shared so the linked and the plain title are visually identical. */
const nameTypographyProps = {
  fontWeight: 600,
  fontSize: 16,
  color: "common.white",
  noWrap: true,
} as const;

type Props = {
  displayName: string;
  /** Set only where the title IS a person whose identity may be disclosed — see the header. */
  profileUrl?: string;
};

/**
 * The channel title in the chat header. A direct channel's title is a person, so it doubles as the
 * way to their profile; a group's is a channel name and leads nowhere. It sits white on the primary
 * header, where the app's link colour would be invisible — the hover underline carries the
 * affordance instead.
 */
export const ChatChannelName = ({ displayName, profileUrl }: Props) => {
  if (!profileUrl) {
    return <Typography {...nameTypographyProps}>{displayName}</Typography>;
  }

  return (
    <Typography
      {...nameTypographyProps}
      component={Link}
      to={profileUrl}
      display="block"
      sx={{
        textDecoration: "none",
        "&:hover": { textDecoration: "underline" },
      }}
    >
      {displayName}
    </Typography>
  );
};
